import { Link, useNavigate } from '@tanstack/react-router'
import { KeyRound, LogOut, ShieldHalf, UserRound, Wrench } from 'lucide-react'
import { Avatar } from '@/components/ui/avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useAuthedMe, useLogout } from '@/features/auth/api'
import { securityPath } from '@/features/shell/nav'

export function UserMenu() {
  const me = useAuthedMe()
  const logout = useLogout()
  const navigate = useNavigate()
  const { user } = me
  const security = securityPath(me)
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-2 rounded-full p-0.5 outline-none transition hover:ring-4 hover:ring-muted focus-visible:ring-2 focus-visible:ring-ring"
          aria-label="Open user menu"
        >
          <Avatar name={user.name} src={user.avatar_url} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel className="flex items-center gap-3 py-2 font-normal">
          <Avatar name={user.name} src={user.avatar_url} className="size-9" />
          <div className="min-w-0">
            <div className="truncate text-sm font-medium text-foreground">{user.name}</div>
            <div className="truncate text-xs text-muted-foreground">{user.email}</div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem asChild>
            <Link to="/settings/profile">
              <UserRound /> Profile
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to={security}>
              <KeyRound /> Security
            </Link>
          </DropdownMenuItem>
          {user.is_platform_admin && (
            <DropdownMenuItem asChild>
              <Link to="/admin">
                <Wrench /> Platform admin
              </Link>
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
        {!user.two_factor_enabled && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to={security} className="text-warning">
                <ShieldHalf className="text-warning" /> Enable two-factor auth
              </Link>
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          variant="destructive"
          onSelect={() =>
            logout.mutate(undefined, {
              onSettled: () => void navigate({ to: '/login' }),
            })
          }
        >
          <LogOut className="text-destructive" /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
